import { SVG, SVGProps } from './svg'

export function IconStar(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path d="M2.2 9.85a.49.49 0 0 1-.18-.54l.08-.25c.06-.2.24-.33.44-.34l6.38-.51 2.45-5.89a.5.5 0 0 1 .51-.32h.26c.21 0 .4.13.47.32l2.46 5.89 6.38.5c.2.02.38.16.44.35l.08.25c.07.2.01.41-.15.54L17.01 14l1.48 6.2c.04.2-.03.41-.2.53l-.28.16a.5.5 0 0 1-.56 0L12 17.58l-5.46 3.33a.5.5 0 0 1-.56 0l-.22-.15a.51.51 0 0 1-.2-.53L7.03 14 2.2 9.85Z" />
    </SVG>
  )
}
